import { InstagramLogoIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Instagram = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <InstagramLogoIcon size={Sizes[size]} {...rest} />;
};

Instagram.displayName = 'Instagram';
